import _ from "lodash";
import { DSProvider } from "@toddle-edu/ds-web";
import React, { useCallback } from "react";
import AILanguageSelection from "AppComponents/ConfigureAIVoice/components/AILanguageSelection";

const AIPanelLanguageSwitch = ({
  mode,
  testId,
  disabled,
  entityType,
  conversationId,
  conversationMetadata,
  onChangeLanguage = _.noop,
}) => {
  const setConfigureAIVoiceRef = useCallback(async node => {
    const languageOptions = _.get(node, "preferredLanguageOptions", []);
    const selectedLanguage = _.get(node, "preferredVoiceObj.language", "en");
    const languageKey = _.find(languageOptions, { key: selectedLanguage })?.lng;
    if (!languageKey) return;
    onChangeLanguage(languageKey);
  }, []);

  return (
    <DSProvider dsVersion={"2.0"}>
      <AILanguageSelection
        mode="edit"
        testId={testId}
        buttonSize="medium"
        isDisabled={disabled}
        entityType={entityType}
        showLanguageLabel={false}
        conversationId={conversationId}
        customRef={setConfigureAIVoiceRef}
        conversationMetadata={conversationMetadata}
        buttonProps={{ style: { padding: "8px" } }}
      />
    </DSProvider>
  );
};

export default AIPanelLanguageSwitch;
